module.exports = __webpack_public_path__ + "images/150_160.jpg";